// Generated by purs version 0.15.10
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Decode_Error from "../Data.Argonaut.Decode.Error/index.js";
import * as Data_Argonaut_Decode_Generic from "../Data.Argonaut.Decode.Generic/index.js";
import * as Data_Argonaut_Encode_Class from "../Data.Argonaut.Encode.Class/index.js";
import * as Data_Argonaut_Encode_Generic from "../Data.Argonaut.Encode.Generic/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Fusion_Data_Bytes from "../Fusion.Data.Bytes/index.js";
import * as Fusion_Data_Duration from "../Fusion.Data.Duration/index.js";
import * as MST_Data_BasicURL from "../MST.Data.BasicURL/index.js";
import * as MST_Data_StreamEvent from "../MST.Data.StreamEvent/index.js";
import * as MST_Data_Units from "../MST.Data.Units/index.js";
import * as MST_Encoding from "../MST.Encoding/index.js";
import * as Test_QuickCheck_Arbitrary from "../Test.QuickCheck.Arbitrary/index.js";
var NetworkReportIsSymbol = {
    reflectSymbol: function () {
        return "NetworkReport";
    }
};
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Show.showString));
var ErrorIsSymbol = {
    reflectSymbol: function () {
        return "Error";
    }
};
var genericShowConstructor1 = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments);
var OkIsSymbol = {
    reflectSymbol: function () {
        return "Ok";
    }
};
var BadCommandIsSymbol = {
    reflectSymbol: function () {
        return "BadCommand";
    }
};
var ConnectionEstablishedIsSymbol = {
    reflectSymbol: function () {
        return "ConnectionEstablished";
    }
};
var StreamNotFoundIsSymbol = {
    reflectSymbol: function () {
        return "StreamNotFound";
    }
};
var showRecord = /* #__PURE__ */ Data_Show.showRecord()();
var streamIdIsSymbol = {
    reflectSymbol: function () {
        return "streamId";
    }
};
var urlIsSymbol = {
    reflectSymbol: function () {
        return "url";
    }
};
var showRecordFieldsConsNil = /* #__PURE__ */ Data_Show.showRecordFieldsConsNil(urlIsSymbol)(MST_Data_BasicURL.showBasicURL);
var showRecordFieldsCons = /* #__PURE__ */ Data_Show.showRecordFieldsCons(streamIdIsSymbol)(showRecordFieldsConsNil)(MST_Data_Units.showStreamId);
var StartedDownloadStreamIsSymbol = {
    reflectSymbol: function () {
        return "StartedDownloadStream";
    }
};
var byteCountIsSymbol = {
    reflectSymbol: function () {
        return "byteCount";
    }
};
var showRecordFieldsCons1 = /* #__PURE__ */ Data_Show.showRecordFieldsCons(byteCountIsSymbol);
var StartedUploadStreamIsSymbol = {
    reflectSymbol: function () {
        return "StartedUploadStream";
    }
};
var versionIsSymbol = {
    reflectSymbol: function () {
        return "version";
    }
};
var EngineInfoIsSymbol = {
    reflectSymbol: function () {
        return "EngineInfo";
    }
};
var StartDownloadStreamIsSymbol = {
    reflectSymbol: function () {
        return "StartDownloadStream";
    }
};
var StartUploadStreamIsSymbol = {
    reflectSymbol: function () {
        return "StartUploadStream";
    }
};
var intervalIsSymbol = {
    reflectSymbol: function () {
        return "interval";
    }
};
var StartPingStreamIsSymbol = {
    reflectSymbol: function () {
        return "StartPingStream";
    }
};
var StopStreamIsSymbol = {
    reflectSymbol: function () {
        return "StopStream";
    }
};
var StopStreamsIsSymbol = {
    reflectSymbol: function () {
        return "StopStreams";
    }
};
var eq = /* #__PURE__ */ Data_Eq.eq(Data_Argonaut_Decode_Error.eqJsonDecodeError);
var eq2 = /* #__PURE__ */ Data_Eq.eq(MST_Data_StreamEvent.eqStreamEventBatch);
var eq3 = /* #__PURE__ */ Data_Eq.eq(MST_Data_Units.eqStreamId);
var eq4 = /* #__PURE__ */ Data_Eq.eq(MST_Data_BasicURL.eqBasicURL);
var eq5 = /* #__PURE__ */ Data_Eq.eq(Fusion_Data_Bytes.eqBytes);
var eq6 = /* #__PURE__ */ Data_Eq.eq(Fusion_Data_Duration.eqDuration);
var encodeRepArgsArgument = /* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeJsonJString);
var gEncodeJsonCons = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(MST_Data_Units.encodeJsonStreamId);
var gEncodeJsonCons1 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(MST_Data_BasicURL.encodeJsonBasicURL)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(urlIsSymbol)();
var gEncodeJsonCons2 = /* #__PURE__ */ gEncodeJsonCons(gEncodeJsonCons1)(streamIdIsSymbol)();
var gEncodeJsonCons3 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Fusion_Data_Bytes.encodeJsonBytes);
var gDecodeJsonCons = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(MST_Data_Units.decodeJsonStreamId));
var gDecodeJsonCons1 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(MST_Data_BasicURL.decodeJsonBasicURL))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(urlIsSymbol)()();
var gDecodeJsonCons2 = /* #__PURE__ */ gDecodeJsonCons(gDecodeJsonCons1)(streamIdIsSymbol)()();
var gDecodeJsonCons3 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Fusion_Data_Bytes.decodeJsonBytes));
var arbGenSumSum = /* #__PURE__ */ Test_QuickCheck_Arbitrary.arbGenSumSum(/* #__PURE__ */ Test_QuickCheck_Arbitrary.arbitraryConstructor(/* #__PURE__ */ Test_QuickCheck_Arbitrary.arbitraryArgument(Test_QuickCheck_Arbitrary.arbString)));
var arbGenSumSum1 = /* #__PURE__ */ Test_QuickCheck_Arbitrary.arbGenSumSum(/* #__PURE__ */ Test_QuickCheck_Arbitrary.arbitraryConstructor(Test_QuickCheck_Arbitrary.arbitraryNoArguments));
var arbitraryRecordInstance = /* #__PURE__ */ Test_QuickCheck_Arbitrary.arbitraryRecordInstance();
var arbitraryRowListCons = /* #__PURE__ */ Test_QuickCheck_Arbitrary.arbitraryRowListCons(MST_Data_Units.arbitraryStreamId)(/* #__PURE__ */ Test_QuickCheck_Arbitrary.arbitraryRowListCons(MST_Data_BasicURL.arbitraryBasicURL)(Test_QuickCheck_Arbitrary.arbitraryRowListNil)()()()(urlIsSymbol))()()()(streamIdIsSymbol);
var InvalidResponse = /* #__PURE__ */ (function () {
    function InvalidResponse(value0) {
        this.value0 = value0;
    };
    InvalidResponse.create = function (value0) {
        return new InvalidResponse(value0);
    };
    return InvalidResponse;
})();
var OtherError = /* #__PURE__ */ (function () {
    function OtherError(value0) {
        this.value0 = value0;
    };
    OtherError.create = function (value0) {
        return new OtherError(value0);
    };
    return OtherError;
})();
var NetworkReport = /* #__PURE__ */ (function () {
    function NetworkReport(value0) {
        this.value0 = value0;
    };
    NetworkReport.create = function (value0) {
        return new NetworkReport(value0);
    };
    return NetworkReport;
})();
var $$Error = /* #__PURE__ */ (function () {
    function $$Error(value0) {
        this.value0 = value0;
    };
    $$Error.create = function (value0) {
        return new $$Error(value0);
    };
    return $$Error;
})();
var Ok = /* #__PURE__ */ (function () {
    function Ok() {

    };
    Ok.value = new Ok();
    return Ok;
})();
var BadCommand = /* #__PURE__ */ (function () {
    function BadCommand(value0) {
        this.value0 = value0;
    };
    BadCommand.create = function (value0) {
        return new BadCommand(value0);
    };
    return BadCommand;
})();
var ConnectionEstablished = /* #__PURE__ */ (function () {
    function ConnectionEstablished() {

    };
    ConnectionEstablished.value = new ConnectionEstablished();
    return ConnectionEstablished;
})();
var StreamNotFound = /* #__PURE__ */ (function () {
    function StreamNotFound(value0) {
        this.value0 = value0;
    };
    StreamNotFound.create = function (value0) {
        return new StreamNotFound(value0);
    };
    return StreamNotFound;
})();
var StartedDownloadStream = /* #__PURE__ */ (function () {
    function StartedDownloadStream(value0) {
        this.value0 = value0;
    };
    StartedDownloadStream.create = function (value0) {
        return new StartedDownloadStream(value0);
    };
    return StartedDownloadStream;
})();
var StartedUploadStream = /* #__PURE__ */ (function () {
    function StartedUploadStream(value0) {
        this.value0 = value0;
    };
    StartedUploadStream.create = function (value0) {
        return new StartedUploadStream(value0);
    };
    return StartedUploadStream;
})();
var EngineInfo = /* #__PURE__ */ (function () {
    function EngineInfo(value0) {
        this.value0 = value0;
    };
    EngineInfo.create = function (value0) {
        return new EngineInfo(value0);
    };
    return EngineInfo;
})();
var Open = /* #__PURE__ */ (function () {
    function Open() {

    };
    Open.value = new Open();
    return Open;
})();
var Close = /* #__PURE__ */ (function () {
    function Close() {

    };
    Close.value = new Close();
    return Close;
})();
var ConnectionFailure = /* #__PURE__ */ (function () {
    function ConnectionFailure(value0) {
        this.value0 = value0;
    };
    ConnectionFailure.create = function (value0) {
        return new ConnectionFailure(value0);
    };
    return ConnectionFailure;
})();
var Message = /* #__PURE__ */ (function () {
    function Message(value0) {
        this.value0 = value0;
    };
    Message.create = function (value0) {
        return new Message(value0);
    };
    return Message;
})();
var StartDownloadStream = /* #__PURE__ */ (function () {
    function StartDownloadStream(value0) {
        this.value0 = value0;
    };
    StartDownloadStream.create = function (value0) {
        return new StartDownloadStream(value0);
    };
    return StartDownloadStream;
})();
var StartUploadStream = /* #__PURE__ */ (function () {
    function StartUploadStream(value0) {
        this.value0 = value0;
    };
    StartUploadStream.create = function (value0) {
        return new StartUploadStream(value0);
    };
    return StartUploadStream;
})();
var StartPingStream = /* #__PURE__ */ (function () {
    function StartPingStream(value0) {
        this.value0 = value0;
    };
    StartPingStream.create = function (value0) {
        return new StartPingStream(value0);
    };
    return StartPingStream;
})();
var StopStream = /* #__PURE__ */ (function () {
    function StopStream(value0) {
        this.value0 = value0;
    };
    StopStream.create = function (value0) {
        return new StopStream(value0);
    };
    return StopStream;
})();
var StopStreams = /* #__PURE__ */ (function () {
    function StopStreams() {

    };
    StopStreams.value = new StopStreams();
    return StopStreams;
})();
var showEngineResponseError = {
    show: function (v) {
        if (v instanceof InvalidResponse) {
            return Data_Argonaut_Decode_Error.printJsonDecodeError(v.value0);
        };
        if (v instanceof OtherError) {
            return v.value0;
        };
        throw new Error("Failed pattern match at MST.Data.EngineCommunication (line 125, column 1 - line 127, column 30): " + [ v.constructor.name ]);
    }
};
var genericEngineResponse_ = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new NetworkReport(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new $$Error(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return Ok.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return new BadCommand(x.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
            return ConnectionEstablished.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
            return new StreamNotFound(x.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))) {
            return new StartedDownloadStream(x.value0.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))) {
            return new StartedUploadStream(x.value0.value0.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr))))))) {
            return new EngineInfo(x.value0.value0.value0.value0.value0.value0.value0.value0);
        };
        throw new Error("Failed pattern match at MST.Data.EngineCommunication (line 109, column 1 - line 109, column 41): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof NetworkReport) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof $$Error) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof Ok) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
        };
        if (x instanceof BadCommand) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))));
        };
        if (x instanceof ConnectionEstablished) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))));
        };
        if (x instanceof StreamNotFound) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))));
        };
        if (x instanceof StartedDownloadStream) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))));
        };
        if (x instanceof StartedUploadStream) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))))));
        };
        if (x instanceof EngineInfo) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0))))))));
        };
        throw new Error("Failed pattern match at MST.Data.EngineCommunication (line 109, column 1 - line 109, column 41): " + [ x.constructor.name ]);
    }
};
var showEngineResponse = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericEngineResponse_)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(MST_Data_StreamEvent.showStreamEventBatch))(NetworkReportIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(ErrorIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor1(OkIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(BadCommandIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor1(ConnectionEstablishedIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(MST_Data_Units.showStreamId))(StreamNotFoundIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(showRecordFieldsCons)))(StartedDownloadStreamIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ showRecordFieldsCons1(showRecordFieldsCons)(Fusion_Data_Bytes.showBytes))))(StartedUploadStreamIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(versionIsSymbol)(Data_Show.showString))))(EngineInfoIsSymbol))))))))))
};
var genericEngineConnectionEv = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return Open.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return Close.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new ConnectionFailure(x.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inr)) {
            return new Message(x.value0.value0.value0);
        };
        throw new Error("Failed pattern match at MST.Data.EngineCommunication (line 132, column 1 - line 132, column 48): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Open) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof Close) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof ConnectionFailure) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
        };
        if (x instanceof Message) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0)));
        };
        throw new Error("Failed pattern match at MST.Data.EngineCommunication (line 132, column 1 - line 132, column 48): " + [ x.constructor.name ]);
    }
};
var showEngineConnectionEvent = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericEngineConnectionEv)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor1({
        reflectSymbol: function () {
            return "Open";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor1({
        reflectSymbol: function () {
            return "Close";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(showEngineResponseError))({
        reflectSymbol: function () {
            return "ConnectionFailure";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(showEngineResponse))({
        reflectSymbol: function () {
            return "Message";
        }
    })))))
};
var genericEngineCommand_ = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new StartDownloadStream(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new StartUploadStream(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new StartPingStream(x.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return new StopStream(x.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inr))) {
            return StopStreams.value;
        };
        throw new Error("Failed pattern match at MST.Data.EngineCommunication (line 108, column 1 - line 108, column 40): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof StartDownloadStream) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof StartUploadStream) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof StartPingStream) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
        };
        if (x instanceof StopStream) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))));
        };
        if (x instanceof StopStreams) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value))));
        };
        throw new Error("Failed pattern match at MST.Data.EngineCommunication (line 108, column 1 - line 108, column 40): " + [ x.constructor.name ]);
    }
};
var showEngineCommand = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericEngineCommand_)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(showRecordFieldsConsNil)))(StartDownloadStreamIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ showRecordFieldsCons1(showRecordFieldsConsNil)(Fusion_Data_Bytes.showBytes))))(StartUploadStreamIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(intervalIsSymbol)(showRecordFieldsConsNil)(Fusion_Data_Duration.showDuration))))(StartPingStreamIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(streamIdIsSymbol)(MST_Data_Units.showStreamId))))(StopStreamIsSymbol))(/* #__PURE__ */ genericShowConstructor1(StopStreamsIsSymbol))))))
};
var eqEngineResponseError = {
    eq: function (x) {
        return function (y) {
            if (x instanceof InvalidResponse && y instanceof InvalidResponse) {
                return eq(x.value0)(y.value0);
            };
            if (x instanceof OtherError && y instanceof OtherError) {
                return x.value0 === y.value0;
            };
            return false;
        };
    }
};
var eq7 = /* #__PURE__ */ Data_Eq.eq(eqEngineResponseError);
var eqEngineResponse = {
    eq: function (x) {
        return function (y) {
            if (x instanceof NetworkReport && y instanceof NetworkReport) {
                return eq2(x.value0)(y.value0);
            };
            if (x instanceof $$Error && y instanceof $$Error) {
                return x.value0 === y.value0;
            };
            if (x instanceof Ok && y instanceof Ok) {
                return true;
            };
            if (x instanceof BadCommand && y instanceof BadCommand) {
                return x.value0 === y.value0;
            };
            if (x instanceof ConnectionEstablished && y instanceof ConnectionEstablished) {
                return true;
            };
            if (x instanceof StreamNotFound && y instanceof StreamNotFound) {
                return eq3(x.value0)(y.value0);
            };
            if (x instanceof StartedDownloadStream && y instanceof StartedDownloadStream) {
                return eq3(x.value0.streamId)(y.value0.streamId) && eq4(x.value0.url)(y.value0.url);
            };
            if (x instanceof StartedUploadStream && y instanceof StartedUploadStream) {
                return eq5(x.value0.byteCount)(y.value0.byteCount) && eq3(x.value0.streamId)(y.value0.streamId) && eq4(x.value0.url)(y.value0.url);
            };
            if (x instanceof EngineInfo && y instanceof EngineInfo) {
                return x.value0.version === y.value0.version;
            };
            return false;
        };
    }
};
var eq8 = /* #__PURE__ */ Data_Eq.eq(eqEngineResponse);
var eqEngineConnectionEvent = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Open && y instanceof Open) {
                return true;
            };
            if (x instanceof Close && y instanceof Close) {
                return true;
            };
            if (x instanceof ConnectionFailure && y instanceof ConnectionFailure) {
                return eq7(x.value0)(y.value0);
            };
            if (x instanceof Message && y instanceof Message) {
                return eq8(x.value0)(y.value0);
            };
            return false;
        };
    }
};
var eqEngineCommand = {
    eq: function (x) {
        return function (y) {
            if (x instanceof StartDownloadStream && y instanceof StartDownloadStream) {
                return eq4(x.value0.url)(y.value0.url);
            };
            if (x instanceof StartUploadStream && y instanceof StartUploadStream) {
                return eq5(x.value0.byteCount)(y.value0.byteCount) && eq4(x.value0.url)(y.value0.url);
            };
            if (x instanceof StartPingStream && y instanceof StartPingStream) {
                return eq6(x.value0.interval)(y.value0.interval) && eq4(x.value0.url)(y.value0.url);
            };
            if (x instanceof StopStream && y instanceof StopStream) {
                return eq3(x.value0.streamId)(y.value0.streamId);
            };
            if (x instanceof StopStreams && y instanceof StopStreams) {
                return true;
            };
            return false;
        };
    }
};
var encodeJsonEngineResponse = {
    encodeJson: /* #__PURE__ */ MST_Encoding["genericEncodeJsonVisonum$prime"](genericEngineResponse_)("response")(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(NetworkReportIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(MST_Data_StreamEvent.encodeJsonStreamEventBatc)))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(ErrorIsSymbol)(encodeRepArgsArgument))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(OkIsSymbol)(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(BadCommandIsSymbol)(encodeRepArgsArgument))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(ConnectionEstablishedIsSymbol)(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(StreamNotFoundIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(MST_Data_Units.encodeJsonStreamId)))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(StartedDownloadStreamIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(gEncodeJsonCons2)())))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(StartedUploadStreamIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons3(gEncodeJsonCons2)(byteCountIsSymbol)())())))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(EngineInfoIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(versionIsSymbol)())())))))))))))
};
var encodeJsonEngineCommand = {
    encodeJson: /* #__PURE__ */ MST_Encoding["genericEncodeJsonVisonum$prime"](genericEngineCommand_)("command")(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(StartDownloadStreamIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(gEncodeJsonCons1)())))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(StartUploadStreamIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons3(gEncodeJsonCons1)(byteCountIsSymbol)())())))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(StartPingStreamIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Fusion_Data_Duration.encodeJsonDuration)(gEncodeJsonCons1)(intervalIsSymbol)())())))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(StopStreamIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons(Data_Argonaut_Encode_Class.gEncodeJsonNil)(streamIdIsSymbol)())())))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(StopStreamsIsSymbol)(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))))))
};
var decodeJsonEngineResponse = {
    decodeJson: /* #__PURE__ */ MST_Encoding["genericDecodeJsonVisonum$prime"](genericEngineResponse_)(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(NetworkReportIsSymbol)(MST_Data_StreamEvent.decodeJsonStreamEventBatc))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(ErrorIsSymbol)(Data_Argonaut_Decode_Class.decodeJsonString))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(OkIsSymbol))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(BadCommandIsSymbol)(Data_Argonaut_Decode_Class.decodeJsonString))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(ConnectionEstablishedIsSymbol))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(StreamNotFoundIsSymbol)(MST_Data_Units.decodeJsonStreamId))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(StartedDownloadStreamIsSymbol)(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(gDecodeJsonCons2)()))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(StartedUploadStreamIsSymbol)(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons3(gDecodeJsonCons2)(byteCountIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(EngineInfoIsSymbol)(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(versionIsSymbol)()())()))))))))))("response")
};
var decodeJsonEngineCommand = {
    decodeJson: /* #__PURE__ */ MST_Encoding["genericDecodeJsonVisonum$prime"](genericEngineCommand_)(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(StartDownloadStreamIsSymbol)(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(gDecodeJsonCons1)()))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(StartUploadStreamIsSymbol)(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons3(gDecodeJsonCons1)(byteCountIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(StartPingStreamIsSymbol)(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Fusion_Data_Duration.decodeJsonDuration))(gDecodeJsonCons1)(intervalIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(StopStreamIsSymbol)(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons(Data_Argonaut_Decode_Class.gDecodeJsonNil)(streamIdIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(StopStreamsIsSymbol))))))("command")
};
var arbitraryEngineResponse = {
    arbitrary: /* #__PURE__ */ Test_QuickCheck_Arbitrary.genericArbitrary(genericEngineResponse_)(/* #__PURE__ */ Test_QuickCheck_Arbitrary.arbitrarySum(/* #__PURE__ */ Test_QuickCheck_Arbitrary.arbitraryConstructor(/* #__PURE__ */ Test_QuickCheck_Arbitrary.arbitraryArgument(MST_Data_StreamEvent.arbitraryStreamEventBatch)))(/* #__PURE__ */ arbGenSumSum(/* #__PURE__ */ arbGenSumSum1(/* #__PURE__ */ arbGenSumSum(/* #__PURE__ */ arbGenSumSum1(/* #__PURE__ */ Test_QuickCheck_Arbitrary.arbGenSumSum(/* #__PURE__ */ Test_QuickCheck_Arbitrary.arbitraryConstructor(/* #__PURE__ */ Test_QuickCheck_Arbitrary.arbitraryArgument(MST_Data_Units.arbitraryStreamId)))(/* #__PURE__ */ Test_QuickCheck_Arbitrary.arbGenSumSum(/* #__PURE__ */ Test_QuickCheck_Arbitrary.arbitraryConstructor(/* #__PURE__ */ Test_QuickCheck_Arbitrary.arbitraryArgument(/* #__PURE__ */ arbitraryRecordInstance(arbitraryRowListCons))))(/* #__PURE__ */ Test_QuickCheck_Arbitrary.arbGenSumSum(/* #__PURE__ */ Test_QuickCheck_Arbitrary.arbitraryConstructor(/* #__PURE__ */ Test_QuickCheck_Arbitrary.arbitraryArgument(/* #__PURE__ */ arbitraryRecordInstance(/* #__PURE__ */ Test_QuickCheck_Arbitrary.arbitraryRowListCons(Fusion_Data_Bytes.arbitraryBytes)(arbitraryRowListCons)()()()(byteCountIsSymbol)))))(/* #__PURE__ */ Test_QuickCheck_Arbitrary.arbGenSumConstructor(/* #__PURE__ */ Test_QuickCheck_Arbitrary.arbitraryArgument(/* #__PURE__ */ arbitraryRecordInstance(/* #__PURE__ */ Test_QuickCheck_Arbitrary.arbitraryRowListCons(Test_QuickCheck_Arbitrary.arbString)(Test_QuickCheck_Arbitrary.arbitraryRowListNil)()()()(versionIsSymbol)))))))))))))
};
export {
    StartDownloadStream,
    StartUploadStream,
    StartPingStream,
    StopStream,
    StopStreams,
    Open,
    Close,
    ConnectionFailure,
    Message,
    NetworkReport,
    $$Error as Error,
    Ok,
    BadCommand,
    ConnectionEstablished,
    StreamNotFound,
    StartedDownloadStream,
    StartedUploadStream,
    EngineInfo,
    InvalidResponse,
    OtherError,
    decodeJsonEngineResponse,
    encodeJsonEngineResponse,
    encodeJsonEngineCommand,
    decodeJsonEngineCommand,
    genericEngineCommand_,
    genericEngineResponse_,
    showEngineCommand,
    showEngineResponse,
    arbitraryEngineResponse,
    eqEngineResponse,
    eqEngineResponseError,
    eqEngineConnectionEvent,
    eqEngineCommand,
    showEngineResponseError,
    showEngineConnectionEvent,
    genericEngineConnectionEv
};
